import SadFaceIcon from "~/components/icons/SadFaceIcon";
import { Button } from "~/components/ui";
import { pensionAssets } from "~/translations/masleka/pensionAssets";
import { useLanguage } from "~/hooks/useLanguage";

type Props = {
  callback: () => void;
  isChargeFailed: boolean;
  isChargedCanceled: boolean;
};

const PaymentNotVerified = ({
  callback,
  isChargeFailed,
  isChargedCanceled,
}: Props) => {
  const { lang } = useLanguage();
  return (
    <div className="mb-4 w-full">
      <SadFaceIcon className="mx-auto mobile:me-[48px] mobile:h-[100px] mobile:w-[100px]" />
      <div className="mt-4 text-center text-2xl font-medium">
        {isChargeFailed
          ? pensionAssets[lang].failedPayment.header
          : isChargedCanceled
          ? pensionAssets[lang].paymentNotVerified.header
          : pensionAssets[lang].chargeNotCancel.header}
      </div>
      <div className="mx-auto w-full text-end lg:w-[50%]">
        {isChargeFailed ? (
          <div className="mx-auto w-full text-end lg:w-[50%]">
            <div>{pensionAssets[lang].failedPayment.list}</div>
            <div className="ps-3">
              <div>{pensionAssets[lang].failedPayment.list1}</div>
              <div>{pensionAssets[lang].failedPayment.list2}</div>
            </div>
          </div>
        ) : (
          <p className="text-center">
            {isChargedCanceled
              ? pensionAssets[lang].paymentNotVerified.content
              : pensionAssets[lang].chargeNotCancel.content}
          </p>
        )}
      </div>
      <div className="mt-8 flex items-center justify-center">
        <Button onClick={callback} className="w-[15%]">
          {pensionAssets[lang].failedPayment.tryAgain}
        </Button>
      </div>
    </div>
  );
};

export default PaymentNotVerified;
